<div class="pt-2 pb-1">
  <div class="px-[12px]">
    <mat-radio-group
      [ngModelOptions]="{ standalone: true }"
      [ngModel]="value$ | async"
      (ngModelChange)="patchValue($event)"
    >
      <mat-radio-button color="primary" [value]="true" data-test="radio-button-true">
        <span class="fs-08 font-normal">True</span>
      </mat-radio-button>
      <mat-radio-button color="primary" [value]="false" data-test="radio-button-false">
        <span class="fs-08 font-normal">False</span>
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>
